__turbopack_context__.v({
  "root": "PlasmicSliderThumb-module__mRy68a__root",
});
